module.exports = __webpack_public_path__ + "static/media/Arial-01.f3e32ef1.svg";